module.exports = __webpack_public_path__ + "static/img/Mercury.44da08b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet/Mercury.svg
// module id = 1412
// module chunks = 0